import { useEffect, useState } from 'react'
import RichEditor from 'components/richEditor/RichEditor'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Icons from 'assets/icons'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import Spinner from 'components/loader/Spinner'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import {useFileReader} from 'hooks/useFileReader'
const TaskEdit = () => {
	const navigate = useNavigate()
	const { showToast } = useToast()
	const { taskId } = useParams()
	const [getTaskDetail, taskDetailLoading] = useRequest()
	const [getProjects] = useRequest()
	const [getPriorities] = useRequest()
	const [uploadFile] = useRequest()
	const [getTypes] = useRequest()
	const [getStatuses] = useRequest()
	const [updateTask, updateLoading] = useRequest()
	const [deleteDocumentReq] = useRequest()
	const [formState, setFormState] = useState()
	const [projects, setProjects] = useState([])
	const [priorities, setPriorities] = useState([])
	const [taskTypes, setTaskTypes] = useState([])
	const [taskStatuses, setTaskStatuses] = useState([])
	const [filesData, setFilesData, convert] = useFileReader()
	useEffect(() => {
		getTaskDetail('/Ticket/GetTicketById', {
			method: 'GET',
			params: {
				id: taskId
			}
		}).then(res => {
			if (res.data.ok) {
				setFormState({...res.data.result, ticketComments:[]})
				setFilesData(res?.data?.result?.ticketDocuments.filter(d => d.ticketCommentId == null))
			}
		})
		getProjects('/Project/GetAllProjects', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setProjects(res.data.result.map(p => ({ label: p.name, value: p.id, name: 'projectId' })))
			}
		})
		getPriorities('/TicketPriority/GetAllTicketPriority', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setPriorities(res.data.result.map(p => ({ label: p.name, value: p.id, name: 'ticketPriorityId' })))
			}
		})
		getTypes('/TicketType/GetAllTicketTypes', { method: 'GET' }).then(res => {
			if (res.data.ok) {
				setTaskTypes(res.data.result.map(p => ({ label: p.name, value: p.id, name: 'ticketTypeId' })))
			}
		})
		getStatuses('/TicketStatus/GetAllTicketStatus', { method: 'GET' }).then(res => {
			if (res.data.ok) {
				setTaskStatuses(res.data.result.map(p => ({ label: p.name, value: p.id, name: 'ticketStatusId' })))
			}
		})
	}, [])
	const handleDropdownChange = (e) => {
		setFormState(prev => ({...prev,[e.name]:e.value}))
	}

	const handleImageChange = async(fileList) => {
		convert(fileList)
		for await (const file of fileList) {
			const formData = new FormData();
			formData.append("File", file);
			formData.append('TicketId', taskId)
			formData.append('CommentId', null)
			uploadFile('/Ticket/AddTicketDocuments', {
				method: 'POST',
				data: formData
			}).then(res => {
				if (res.data.ok) {
					getTaskDetail('/Ticket/GetTicketById',{
						method:'GET',
						params:{
							id:taskId
						}
					}).then(res => {
						if (res.data.ok) {
							setFilesData(res?.data?.result?.ticketDocuments.filter(d => d.ticketCommentId == null))
						}
					})
				}
			})
		}
		
	}
	const removeFile = (fileId) => {
		const formData = new FormData()
		formData.append('Id',fileId)
		deleteDocumentReq('/Ticket/DeleteTicketDocuments',{
			method:'DELETE',
			data:formData
		}).then(res => {
			if (res.data.ok) {
				setFilesData(prev => ([...prev.filter(f => f.id != fileId)]))
			}
		})
	}
	const handleSubmit = () => {
		updateTask('/Ticket/UpdateTickets', {
			method: 'PUT',
			data: formState
		}).then(res => {
			if (res.data.ok) {
				showToast('İşlem başarılı', 'success')
				navigate(-1)
			}
		})
	}
	if (!formState && !taskDetailLoading) {
		return <div>Veri Bulunamadı</div>
	}
	return (
		<AnimatedSpan className='page-container d-flex flex-column'>
			{
				taskDetailLoading ? <Spinner size={3} />
				: <div className='card'>
				<div className='row'>
						<div className='col-md-12'>
							<div className='heading-2'>Görev Düzenle</div>
						</div>
					</div>
					<div className='w-100 d-flex flex-column gap-3'>
						<div className="row">
						<div className='col-md-12'>
								<input className='default-input' type='text' name='title' value={formState.title} onChange={(e) => setFormState(prev => ({...prev,[e.target.name]:e.target.value}))} placeholder='Görev Başlığı' />
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<DefaultSelect
									value={projects.find(p => p.value == formState.projectId)}
									placeholder='Proje'
									handleChange={(e) => handleDropdownChange(e)}
									selectOptions={projects}
								/>
							</div>
							<div className='col-md-6'>
								<DefaultSelect
									value={taskStatuses.find(p => p.value == formState.ticketStatusId)}
									placeholder='Talep Statüsü'
									handleChange={(e) => handleDropdownChange(e)}
									selectOptions={taskStatuses}
								/>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<DefaultSelect
									placeholder='Öncelik'
									value={priorities.find(p => p.value == formState.ticketPriorityId)}
									handleChange={(e) => handleDropdownChange(e)}
									selectOptions={priorities}
								/>
							</div>
							<div className='col-md-6'>
								<DefaultSelect
									placeholder='Talep Tipi'
									value={taskTypes.find(p => p.value == formState.ticketTypeId)}
									handleChange={(e) => handleDropdownChange(e)}
									selectOptions={taskTypes}
								/>
							</div>
						</div>
						<div className='row'>
							<div className='col-12'>
								<RichEditor defaultContentState={formState.description} setState={(value) => setFormState(prev => ({...prev,description:value}))} />
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<label className='filterTask-file-upload--form--row--item--file-uploader--label' htmlFor='file-uploader'>
									<span className='filterTask-file-upload--form--row--item--file-uploader--label--text'>Dosya yüklemek için tıklayınız</span>
								</label>
								<input
									type='file'
									// accept="image/*,video/*"
									onChange={(e) =>handleImageChange(e.target.files)}
									multiple
									id='file-uploader'
									className='filterTask-file-upload--form--row--item--file-uploader--input'
								/>
							</div>
							<div className='ml-4 d-flex w-100 mt-2 gap-3'>
								{filesData?.length > 0 &&
									filesData?.map((file, i) => (
										<div className='text-sm comment-fileList w-unset' key={i}>
											<div className='d-flex align-items-center'>{file?.loading ? <Spinner size={.8} /> : <Icons.check size={16} />} {file?.fileName}</div>
											<Icons.delete onClick={() => {removeFile(file.id)}} size={16} />
										</div>
									))}
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12 d-flex justify-content-end gap-3'>
								<Link to={-1} className='btn-danger-outline'>
									Vazgeç
								</Link>
								<Button className='btn-success' title='Kaydet' loading={updateLoading} disabled={updateLoading} handleClick={handleSubmit} />
							</div>
						</div>
					</div>
				</div>
			}
			
		</AnimatedSpan>
	)
}

export default TaskEdit
